import { useIntl } from '@weenat/wintl';
import { useMemo } from 'react';
import TimeSteps, { allAvailableTimeSteps } from '../../enums/TimeSteps';
import { useHistoryContext } from '../../HistoryContext';
import { getAvailableTimeStepsForCustomPeriods } from './history';
export const useAvailableStepsAsOptions = ({ timezone, additionalAggregates, capitalizeLabels = false }) => {
    const { t } = useIntl();
    const { historyState } = useHistoryContext();
    return useMemo(() => {
        const ts = getAvailableTimeStepsForCustomPeriods({
            period: historyState.selectedPeriod,
            timezone,
            metrics: historyState.selectedMetrics,
            perDevice: historyState.isAggregateBySerial
        });
        if (additionalAggregates) {
            ts.push(TimeSteps.per2Hours, TimeSteps.per3Hours, TimeSteps.per6Hours, TimeSteps.per8Hours, TimeSteps.per12Hours);
        }
        return ts
            .sort((firstTimeStep, secondTimeStep) => allAvailableTimeSteps.findIndex((value) => value === firstTimeStep) -
            allAvailableTimeSteps.findIndex((value) => value === secondTimeStep))
            .map((timeStep) => ({
            label: t(`timeSteps.${timeStep}`, { capitalize: capitalizeLabels }),
            value: timeStep
        }));
    }, [
        historyState.selectedPeriod,
        historyState.selectedMetrics,
        historyState.isAggregateBySerial,
        timezone,
        additionalAggregates,
        t,
        capitalizeLabels
    ]);
};
